import { useEffect, useRef, useState } from 'react';
import CallIcon from '../assets/icons/callicon';
import EmailIcon from '../assets/icons/emailIcon';
import BurgerMenuIcon from '../assets/icons/burgerMenu';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { zeccanavlogo } from '../assets/images';

const Navbar = () => {
	const menuItems = [
		{ name: 'Home', path: '/' },
		{ name: 'About Us', path: '/about' },
		{ name: 'Products', path: '/products' },
		{ name: 'Contact Us', path: '/contact', isButton: true },
	];

	const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
	const toggleMobileMenu = () => setIsMobileMenuOpen(!isMobileMenuOpen);
	const location = useLocation();
	const menuRef = useRef(null);
	const navigate = useNavigate();

	const burgerRef = useRef(null);

	useEffect(() => {
		function handleClickOutside(event) {
			if (
				menuRef.current &&
				!menuRef.current.contains(event.target) &&
				burgerRef.current &&
				!burgerRef.current.contains(event.target)
			) {
				setIsMobileMenuOpen(false);
			}
		}

		if (isMobileMenuOpen) {
			document.addEventListener('mousedown', handleClickOutside);
		} else {
			document.removeEventListener('mousedown', handleClickOutside);
		}

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, [isMobileMenuOpen]);

	return (
		<div className="w-full flex justify-center">
			<div className="absolute top-[24px] max-w-[1400px] xl:w-[1400px] lg:w-[900px] md:w-[700px] sm:w-[425px] ms:w-full xs:w-full h-[50px] flex justify-between items-center opacity-100 xl:px-[100px] lg:px-0 md:px-0 sm:px-[20px] px-[20px]">
				<img
					src={zeccanavlogo}
					alt="ZECCA Logo"
					onClick={() => navigate('/')}
					className="cursor-pointer xl:w-[122px] lg:w-[122px] md:w-[122px] sm:w-[133px] w-[133px] xl:h-[50px] lg:h-[50px] md:h-[50px] sm:h-[40px] h-[40px] object-contain"
				/>
				<div
					className="hidden lg:flex items-center gap-[24px]"
					style={{
						width: '606px',
						height: '42px',
						opacity: 1,
					}}
				>
					<div className="relative w-[458px] h-[42px] rounded-[30px] flex items-center opacity-100 justify-between">
						{menuItems.map((item, index) =>
							item.isButton ? (
								<Link
									key={index}
									to={item.path}
									className="bg-[#FFFFFF] w-fit h-[42px] rounded-[30px] shadow-[0px_4px_20px_0px_#00000014] flex items-center justify-center gap-[10px] px-[20px] pt-[10px] pb-[11px]"
								>
									<span className="text-[14px] leading-[100%] font-google font-[500] text-black">
										{item.name}
									</span>
								</Link>
							) : (
								<Link
									key={index}
									to={item.path}
									className={`text-[16px] font-[400] leading-[100%] font-google ${
										location.pathname === item.path
											? 'underline text-[#FFFFFF] font-[500]'
											: 'text-white'
									}`}
								>
									{item.name}
								</Link>
							),
						)}
					</div>

					<div
						className="mx-2"
						style={{
							width: '1px',
							height: '24px',
							borderRight: '1px solid #DEDEDE',
							opacity: 1,
						}}
					></div>
					<div
						className="w-[100px] h-[42px] flex items-center justify-center gap-[16px]"
						style={{
							opacity: 1,
						}}
					>
						<a
							href="tel:+91 99090 09023"
							className="w-[42px] h-[42px] rounded-[30px] shadow-[0px_4px_20px_0px_#00000014] bg-[#FFFFFF] flex items-center justify-center"
							style={{ opacity: 1 }}
						>
							<CallIcon />
						</a>
						<a
							href="mailto:contact@zecca.in"
							className="w-[42px] h-[42px] rounded-[30px] shadow-[0px_4px_20px_0px_#00000014] bg-[#FFFFFF] flex items-center justify-center"
							style={{ opacity: 1 }}
						>
							<EmailIcon />
						</a>
					</div>
				</div>
				<div className="lg:hidden flex items-center gap-4">
					<div className="flex items-center gap-[12px]">
						<a
							href="tel:+91 99090 09023"
							className="w-[40px] h-[40px] rounded-[30px] shadow-[0px_4px_20px_0px_#00000014] bg-[#FFFFFF] flex items-center justify-center"
						>
							<CallIcon />
						</a>
						<a
							href="mailto:contact@zecca.in"
							className="w-[40px] h-[40px] rounded-[30px] shadow-[0px_4px_20px_0px_#00000014] bg-[#FFFFFF] flex items-center justify-center"
						>
							<EmailIcon />
						</a>
						<div
							onClick={toggleMobileMenu}
							ref={burgerRef}
							className="w-[40px] h-[40px] rounded-[30px] shadow-[0px_4px_20px_0px_#00000014] bg-[#FFFFFF] flex items-center justify-center"
						>
							<BurgerMenuIcon />
						</div>
					</div>
				</div>
			</div>

			<div className="absolute top-[98px] max-w-[1400px] xl:w-[1400px] lg:w-[900px] md:w-[700px] sm:w-[425px] ms:w-full xs:w-full xl:px-[100px] lg:px-0 md:px-0 sm:px-[20px] px-[20px]">
				<div
					className="border-t border-[#DEDEDE] opacity-100 rounded-full"
					style={{ height: '0px' }}
				></div>
			</div>
			{isMobileMenuOpen && (
				<div
					className="absolute top-[80px] left-1/2 transform -translate-x-1/2 w-[90%] bg-white rounded-[16px] shadow-[0_4px_20px_0_#0000001A] flex flex-col items-start p-5 gap-4 z-50"
					ref={menuRef}
				>
					{menuItems.map((item, index) => (
						<Link
							key={index}
							to={item.path}
							onClick={() => setIsMobileMenuOpen(false)}
							className={`text-[16px] font-[400] font-[Google Sans] w-full py-2 ${
								location.pathname === item.path
									? 'text-[#000000] font-[500]'
									: 'text-[#555]'
							}`}
						>
							{item.name}
						</Link>
					))}
				</div>
			)}
		</div>
	);
};

export default Navbar;
